import * as React    from 'react';

import { Container } from 'src/components/common/flex/vgap/ui';



type Props = {
  size: number;
}
export const VGap: React.FC<Props> = ({
  size
}) => {
  return (
    <Container size = { size } />
  );
};
